import { render, staticRenderFns } from "./3dGlasses.vue?vue&type=template&id=7f992735&scoped=true&"
import script from "./3dGlasses.vue?vue&type=script&lang=js&"
export * from "./3dGlasses.vue?vue&type=script&lang=js&"
import style0 from "./3dGlasses.vue?vue&type=style&index=0&id=7f992735&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f992735",
  null
  
)

export default component.exports